import { gql } from '@apollo/client';

export const FEATURE_ONBOARDING_STATUS_QUERY = gql`
  query featureOnboardingStatus($featureName: String!) {
    featureOnboardingStatus(featureName: $featureName)
  }
`;

export const ONBOARDING_MUTATION = gql`
  mutation UpdateUserOnboarding($featureId: ID!, $status: String!) {
    updateUserOnboarding(featureId: $featureId, status: $status) {
      success
    }
  }
`;

export const UX_FEATURE_QUERY = gql`
  query uxFeature($featureName: String!) {
    uxFeature(featureName: $featureName) {
      id
    }
  }
`;
